<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
            <v-flex xs12 md8>
                <material-card>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-container fill-height fluid grid-list-xl>
                            <v-layout wrap style="background: #fff;" class="borderTop borderRight">
<!--                                <v-flex md12 xs12>-->
<!--                                    <v-layout row wrap>-->
                                        <v-flex md2 xs2 class="conTh py-2 borderBottom borderTop">ID</v-flex>
                                        <v-flex md4 xs4 class="py-2 borderBottom ">
                                        </v-flex>
                                        <v-flex md2 xs2 class="conTh py-2 borderBottom">닉네임</v-flex>
                                        <v-flex md4 xs4 class="py-2 borderBottom ">
                                            {{STORE_NICKNAME}}
                                        </v-flex>

                                        <v-flex md2 xs2 class="conTh py-2 borderBottom">타입</v-flex>
                                        <v-flex md4 xs4 class="py-2 borderBottom ">
                                            <v-select
                                                    v-model="model.type"
                                                    :items="OPTIONS_CONTENTS_TYPE.slice(1,OPTIONS_CONTENTS_TYPE.length-1)"
                                                    label="book"
                                                    flat
                                                    hide-details
                                                    solo
                                            ></v-select>
                                        </v-flex>

                                        <v-flex md2 xs2 class="conTh py-2 borderBottom ">카테고리</v-flex>
                                        <v-flex md4 xs4 class="py-2 borderBottom ">
                                            <v-select
                                                    v-model="model.category"
                                                    :items="OPTIONS_CATEGORY.slice(1,OPTIONS_CATEGORY.length)"
                                                    label="카테고리 선택"
                                                    flat
                                                    hide-details
                                                    solo
                                            ></v-select>
                                        </v-flex>

                                        <v-flex md2 xs2 class="conTh py-2 borderBottom">게시상태</v-flex>
                                        <v-flex md10 xs10 class="py-2 borderBottom ">
                                            <v-select
                                                    v-model="model.open_yn"
                                                    :items="OPTIONS_OPEN_STATUS.slice(1,OPTIONS_OPEN_STATUS.length)"
                                                    label="게시"
                                                    flat
                                                    hide-details
                                                    solo
                                            ></v-select>
                                        </v-flex>
<!--                                    </v-layout>-->
<!--                                </v-flex>-->


                                <!--book 옵션-->
<!--                                <v-flex md12 xs12 v-if="model.type === 'BOOK'">-->
<!--                                    <v-layout row wrap>-->

                                        <v-flex md2 xs2 v-if="model.type === 'BOOK'" class="conTh py-2 borderBottom">ISBN</v-flex>
                                        <v-flex md8 xs8 v-if="model.type === 'BOOK'" class="py-2 borderBottom ">
                                            <v-text-field
                                                    v-model="model.contentsDetail.isbn"
                                                    label="ISBN"
                                                    solo
                                                    hide-details
                                                    flat
                                                    disabled
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex md2 xs2 v-if="model.type === 'BOOK'" pa-0 pr-3 class=" borderBottom verticalMiddle text-align-center">
                                            <v-btn color="blue-grey darken-1" dark block @click="searchBook()">ISBN 검색</v-btn>
                                        </v-flex>

                                        <v-flex md2 xs2 v-if="model.type === 'BOOK'" class="conTh py-2 borderBottom ">도서명</v-flex>
                                        <v-flex md10 xs10 v-if="model.type === 'BOOK'" class="py-2 borderBottom ">
                                            <v-text-field
                                                    v-model="model.contentsDetail.title"
                                                    label="도서명"
                                                    solo
                                                    hide-details
                                                    flat
                                                    disabled
                                            ></v-text-field>
                                        </v-flex>


                                        <v-flex md2 xs2 v-if="model.type === 'BOOK'" class="conTh py-2 borderBottom">도서저자</v-flex>
                                        <v-flex md10 xs10  v-if="model.type === 'BOOK'" class="py-2 borderBottom ">
                                            <v-text-field
                                                    v-model="model.contentsDetail.authors"
                                                    label="도서저자"
                                                    solo
                                                    hide-details
                                                    flat
                                                    disabled
                                            ></v-text-field>
                                        </v-flex>

<!--                                    </v-layout>-->

<!--                                </v-flex>-->

                                <!--book 옵션-->
                                <!--video 옵션-->
                                <v-flex md4 xs4 v-if="model.type === 'VIDEO'">
                                    <v-layout row wrap>
                                        <v-flex md6 xs6 class="conTh py-2 borderBottom">파일명</v-flex>
                                        <v-flex md6 xs6 class="py-2 borderBottom ">
                                            <v-text-field
                                                    v-model="model.video_name"
                                                    label=""
                                                    solo
                                                    hide-details
                                                    flat

                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex md6 xs6 class="conTh py-2 borderBottom ">파일크기</v-flex>
                                        <v-flex md6 xs6 class="py-2 borderBottom  borderRight">
                                            <v-text-field
                                                    v-model="model.video_size"
                                                    label=""
                                                    solo
                                                    hide-details
                                                    flat
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex md6 xs6 class="conTh py-2 borderBottom">재생시간</v-flex>
                                        <v-flex md6 xs6 class="py-2 borderBottom  borderRight">
                                            <v-text-field
                                                    v-model="model.video_time"
                                                    label=""
                                                    solo
                                                    hide-details
                                                    flat
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex md2 xs2 class=" borderBottom verticalMiddle text-align-center" v-if="model.type === 'V'">
                                    <v-btn color="blue-grey darken-1" dark large style="width:80%; height:80%; dispaly:inline">파일 선택</v-btn>
                                </v-flex>

                                <!--video 옵션-->

<!--                                <v-flex md12 xs12>-->
<!--                                    <v-layout row wrap>-->
                                        <v-flex md2 xs2 class="conTh py-2 borderBottom">제목</v-flex>
                                        <v-flex md10 xs10 class="py-2 borderBottom">
                                            <v-text-field
                                                    v-model="model.title"
                                                    label="제목을 입력해주세요"
                                                    solo
                                                    hide-details
                                                    flat
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex md2 xs2 class="conTh py-2 borderBottom">내용</v-flex>
                                        <v-flex md10 xs10 class="py-2 borderBottom">
                                            <div class="detailInfo">
                                                <editor api-key='40gjhoe9qw4arr3ts44g2km7b2h1fli0elf1ymr6dh2k1mhb'
                                                        cloud-channel='dev' :init="editorConfig" v-model="model.content"></editor>
                                            </div>
                                        </v-flex>

                                        <v-flex md2 xs2 class="conTh py-2 borderBottom">태그</v-flex>
                                        <v-flex md10 xs10 class="py-2 borderBottom">
                                            <v-combobox
                                                    v-model="model.tags"
                                                    :items="items"
                                                    :delimiters="[' ', ',']"
                                                    label="태그와 태그는 쉼표나 공백으로 구분하여 입력하실 수 있습니다"
                                                    chips
                                                    clearable
                                                    solo
                                                    multiple
                                                    flat
                                                    hide-details

                                            >
                                                <template slot="selection" slot-scope="data">
                                                    <v-chip close @input="remove(data.item)">
                                                        <strong>{{ data.item }}</strong>&nbsp;
                                                    </v-chip>
                                                </template>
                                            </v-combobox>
                                        </v-flex>
<!--                                    </v-layout>-->
<!--                                </v-flex>-->

                                <v-flex xs12 text-xs-right class="borderNone">
                                    <v-btn class="mx-0 mr-1 font-weight-light" color="primary" outline @click="cancel()">취소</v-btn>
                                    <v-btn class="mx-0 font-weight-light" color="primary" @click="save()">저장</v-btn>
                                </v-flex>

                            </v-layout>
                        </v-container>
                    </v-form>
                </material-card>
            </v-flex>

            <!--book 이미지-->
            <v-flex xs12 md4 v-if="model.type  === 'BOOK'">
                <material-card class="v-card-profile">
                    <v-card-text class="text-xs-center">
                        <img v-if="model.contentsDetail.thumbnail" :src="model.contentsDetail.thumbnail" width="150px;">
                        <img v-else src="../../assets/images/book_no_img.jpg">
                    </v-card-text>
                </material-card>
            </v-flex>
            <!--book 이미지-->

            <!--&lt;!&ndash;video 이미지&ndash;&gt;-->
            <!--<v-flex xs12 md4 v-if="model.type === 'V'">-->
                <!--<material-card class="v-card-profile">-->
                    <!--<v-card-text class="text-xs-center">-->
                        <!--<img src="../../assets/images/book_no_img.jpg.jpg">-->
                    <!--</v-card-text>-->
                <!--</material-card>-->
            <!--</v-flex>-->


            <SearchBookDialog v-show="searchBookDialog" ref="searchBookDialog" v-on:selectProduct="selectProduct"></SearchBookDialog>
            <!--video 이미지-->
        </v-layout>
    </v-container>

</template>

<script>
	import { Contents } from '../../service/model/Contents'

	import * as contentsApi from '../../service/api/contents-api'

	import MyMixinCommon from '../../mixins/MyMixinCommon';
	import { mapActions } from 'vuex'
	import SearchBookDialog from "../../components/dialog/SearchBookDialog";
	import Editor from '@tinymce/tinymce-vue';

	export default {
		mixins: [ MyMixinCommon ],
		components: {
			'editor': Editor,
			SearchBookDialog
		},
		data: () => ({
			valid: true,
			model: new Contents(),
			items: [],
			dialog: false,
			searchBookDialog: false,
		}),
		created() {
			this.valid = false
			this.model.type = 'BOOK'
			this.model.open_yn = true
		},
		methods: {
			...mapActions( 'contents', [ 'demoAddContent' ] ),

			/////////////////////////////////////////////////// FUNC /////////////////////////////////////////////////////////
			cancel() {
				this.$router.back()
			},

			save() {

				if( ! this.$refs.form.validate() ) {
					this.$dialog.alert( '필수 정보를 입력해주세요.' )
					return;
				}

				if( ! this.model.type ) {
					this.$dialog.alert( '타입를 선택해주세요.' )
					return;
				}

				if( ! this.model.contentsDetail.isbn || ! this.model.contentsDetail.title  ) {
					this.$dialog.alert( 'ISBN 검색하여 도서정보를 입력해주세요.' )
					return;
				}

				if( ! this.model.category ) {
					this.$dialog.alert( '카테고리를 선택해주세요.' )
					return;
				}

				if( ! this.model.open_yn ) {
					this.$dialog.alert( '게시상태를 선택해주세요.' )
					return;
				}

				if( ! this.model.title ) {
					this.$dialog.alert( '제목을 입력해주세요.' )
					return;
				}

				if( ! this.model.content ) {
					this.$dialog.alert( '내용를 입력해주세요.' )
					return;
				}

				this.$dialog.confirm( '저장 하시겠습니까?' )
				.then( dialog => {
                    let data = {
                        type: this.model.type,
                        title: this.model.title,
                        content: this.model.content,
                        category: this.model.category,
                        open_yn: this.model.open_yn,
                        contents_detail: {
                            contents_url: this.model.contentsDetail.contents_url,
                            thumbnail_url: this.model.contentsDetail.thumbnail_url,
                            title: this.model.contentsDetail.title,
                            content: this.model.contentsDetail.content,
                            isbn: this.model.contentsDetail.isbn,
                            authors: this.model.contentsDetail.authors,
                            price: this.model.contentsDetail.price,
                            sale_price: this.model.contentsDetail.sale_price,
                            publisher: this.model.contentsDetail.publisher,
                            pubdate: this.model.contentsDetail.pubdate
                        },
                        tags: this.model.tags
                    }
                    this.reqCreate(data)
				} )
				.catch( function() {
				} )


			},
			remove( item ) {
				if( this.model.tags ) {
					this.model.tags.splice( this.model.tags.indexOf( item ), 1 )
					this.model.tags = [ ...this.model.tags ]
				}
			},
			searchBook() {
				this.$refs.searchBookDialog.openDialog()
			},
			selectProduct( item ) {

				this.model.contentsDetail = item
				this.model.contentsDetail.content = item.contents
				this.model.contentsDetail.contents_url = item.url
				this.model.contentsDetail.thumbnail_url = item.thumbnail
				this.model.contentsDetail.pubdate = item.datetime

			},

			/////////////////////////////////////////////////// REQ /////////////////////////////////////////////////////////

            reqCreate(data){
	            return contentsApi.createContents( data ).then( res => {
		            this.$router.push( { name: 'contents' } );
	            }).catch(e=>{
		            this.$dialog.alert(e.message)
	            })
            }
		}
	}

</script>
